import React from 'react';
export function SurveyHeader() {
  return <div className="flex flex-col items-center text-center mb-8 sm:mb-12" data-id="element-21" data-mp="1x6bh2vdlt5zx">
      {/* Logo */}
      <div className="flex flex-col items-center mb-6" data-id="element-22" data-mp="17hsycnpp84t6">
        <img src="https://cdn.magicpatterns.com/uploads/shUFx1Totj4o6H86R7sMup/logo_blauw_slogan.png" alt="krnwtr+ — de duurzame dorstlesser" className="w-auto h-20 sm:h-24 max-w-full" data-id="element-23" data-mp="sltjmu8336f2" />
      </div>

      {/* Titles */}
      <h2 className="text-[#0b2a4a] text-2xl sm:text-3xl font-bold mb-3" data-id="element-24" data-mp="jqwzj6mts9cf">
        KRNWTR+ Klanttevredenheid
      </h2>
      <p className="text-[#4b5563] text-sm sm:text-base max-w-md mx-auto leading-relaxed" data-id="element-25" data-mp="9uu0i9n9sqtp">
        We zijn benieuwd hoe de service is verlopen!
      </p>
    </div>;
}